// extracted by mini-css-extract-plugin
module.exports = {"footerLogo":"LoadingPage_footerLogo_33STp"};